import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4h6v6h-6zm10 0h6v6h-6zm-10 10h6v6h-6zm10 3h6","key":"svg-0"}]]

const IconCategoryMinus = createReactComponent('outline', 'category-minus', 'CategoryMinus', __iconNode);

export default IconCategoryMinus;